import { SvgIcon } from '@mui/material';

type QuickChatIconSize = 'sm' | 'md' | 'lg' | 'xl';
type QuickChatIconVariant = 'filled' | 'outlined';

const SIZE_MAP: Record<QuickChatIconSize, number> = {
  sm: 12,
  md: 18,
  lg: 24,
  xl: 32,
};

interface QuickChatIconProps {
  size?: number | QuickChatIconSize;
  variant?: QuickChatIconVariant;
  color?: string;
  fillColor?: string;
}

const ASPECT_RATIO = 278 / 330;
const PATH_1 =
  'M 0,19 C 5.122,9.110 9.255,4.508 15.690,1.531 C 16.793,1.021 17.897,0.510 19,0 C 116.667,0 214.333,0 312,0 C 319.490,3.642 325.209,8.867 327.873,14.502 C 328.582,16.001 329.291,17.501 330,19 C 330,27.333 330,35.667 330,44 C 325.459,61.019 321.252,68.792 311.026,79.059 C 301.267,88.856 292.705,93.879 280.391,97.028 C 272.917,98.939 268.822,98.999 147.090,98.994 C 59.949,98.990 20.304,98.657 17.595,97.905 C 12.625,96.525 3.617,88.102 1.551,82.903 C 1.034,81.602 0.517,80.301 0,79 C 0,59 0,39 0,19 Z';
const PATH_2 =
  'M 0,150 C 2.967,143.927 5.684,140.363 7.951,138.163 C 15.767,130.578 8.680,131 128.428,131.006 C 199.102,131.010 236.766,131.363 239.225,132.046 C 244.925,133.629 251.086,138.907 254.207,144.882 C 256.818,149.881 257,151.019 257,162.404 C 257,175.909 255.636,182.821 251.005,192.770 C 244.645,206.434 233.729,217.254 219.500,223.998 C 205.994,230.399 206.559,230.350 139.500,230.952 C 119.167,231.135 98.833,231.317 78.500,231.500 C 76,233.312 73.500,235.123 71,236.935 C 66.875,239.924 62.446,243.074 61.157,243.935 C 59.868,244.796 57.843,246.253 56.657,247.174 C 54.718,248.679 38.626,260.242 30.209,266.179 C 22.945,271.303 19.395,273.976 17.250,275.940 C 16.500,276.627 15.750,277.313 15,278 C 11.333,278 7.667,278 4,278 C 2.667,276.333 1.333,274.667 0,273 C 0,232 0,191 0,150 Z';

const QuickChatIcon = ({ size = 'md', variant = 'filled', color = '#3650DE', fillColor }: QuickChatIconProps) => {
  const resolvedSize = typeof size === 'string' ? SIZE_MAP[size] : size;
  const isOutlined = variant === 'outlined';
  const pathFill = isOutlined ? (fillColor ?? 'none') : 'currentColor';

  return (
    <SvgIcon
      sx={{ width: resolvedSize, height: resolvedSize * ASPECT_RATIO, color }}
      viewBox="0 0 330 278"
    >
      <path
        d={PATH_1}
        fill={pathFill}
        stroke={isOutlined ? 'currentColor' : undefined}
        strokeWidth={isOutlined ? 20 : undefined}
      />
      <path
        d={PATH_2}
        fill={pathFill}
        stroke={isOutlined ? 'currentColor' : undefined}
        strokeWidth={isOutlined ? 20 : undefined}
      />
    </SvgIcon>
  );
};

export default QuickChatIcon;
